import { render, staticRenderFns } from "./ForumOutside.vue?vue&type=template&id=70b2e08b&scoped=true&"
import script from "./ForumOutside.vue?vue&type=script&lang=js&"
export * from "./ForumOutside.vue?vue&type=script&lang=js&"
import style0 from "./ForumOutside.vue?vue&type=style&index=0&id=70b2e08b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2e08b",
  null
  
)

export default component.exports